import { createAction, props } from '@ngrx/store';
import { ComponentState } from './master-view.state';

export const addComponent = createAction('[Master View] Add Component', props<{ item: ComponentState }>());

export const removeComponent = createAction('[Master View] Remove Component', props<{ id: string }>());

export const updateComponent = createAction('[Master View] Update Component', props<{ item: ComponentState }>());

export const setComponents = createAction('[Master View] Set Components', props<{ components: ComponentState[] }>());

export const clearComponents = createAction('[Master View] Clear Components');

export const selectComponentById = createAction('[Master View] Select Component By Id', props<{id: string}>());

export const publishEvent = createAction('[Master View] Publish Event', props<{eventName: string; payload: any}>());